import React from "react";
import data from "@emoji-mart/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export const displayEmoji = (emojicon, color, size, style = {}) => {
  if (emojicon && emojicon != "") {
    if (emojicon.split("/")[0] === "emoji") {
      return getEmojiCode(emojicon.split("/")[1]);
    } else if (emojicon.split("/")[0] === "icon") {
      const iconType = emojicon.split("/")[1].split("#")[0];
      const iconValue = emojicon.split("/")[1].split("#")[1];
      if (iconValue === "bolt") {
        return <FontAwesomeIcon icon={solid("bolt")} color={color} size={size} style={style} />;
      }
      return <FontAwesomeIcon icon={[iconType, iconValue]} color={color} size={size} style={style} />;
    } else {
      return getEmojiCode(emojicon);
    }
  }
  return <FontAwesomeIcon icon={solid("bolt")} color={color} size={size} style={style} />;
};

export const getEmojiCode = (emoji) => {
  if (emoji) {
    return data.emojis[emoji].skins[0].native;
  } else {
    return null;
  }
};
